import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("cp_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("cp_token");
      setUser(false);
    });
  }, []);

  const signIn = ({ token, user: u }) => {
    localStorage.setItem("cp_token", token);
    setUser(u);
  };
  const signOut = () => {
    localStorage.removeItem("cp_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, signIn, signOut }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
